/* Niclas + ChatGPT | 2026-10-02 | US and Canada store suggestions */
(function () {
  if (location.hostname.replace('www.', '') !== 'avolt.com') return;
  if (/googlebot|bingbot|adsbot|duckduckbot|yandexbot|baiduspider|slackbot|twitterbot|linkedinbot|gptbot|oai-searchbot/i.test(navigator.userAgent || '')) return;
  const modal = document.getElementById('avoltStoreModal');
  if (!modal) return;
  const dismissed = key => { try { return sessionStorage.getItem(key); } catch { return false; } };
  const root = window.Shopify?.routes?.root || '/';
  fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`)
    .then(res => res.json())
    .then(data => {
      const country = data.detected_values?.country?.handle;
      const markets = { US: { prefix: 'us', origin: 'https://us.avolt.com' }, CA: { prefix: 'ca', origin: 'https://ca.avolt.com' } };
      const market = markets[country];
      if (!market || dismissed(`avolt_notified_${market.prefix}`)) return;
      const go = document.getElementById('avoltGoStore');
      const stay = document.getElementById('avoltStayEU');
      document.getElementById('avoltStoreTitle').textContent = modal.dataset[`${market.prefix}Title`];
      document.getElementById('avoltStoreMessage').textContent = modal.dataset[`${market.prefix}Body`];
      go.textContent = modal.dataset[`${market.prefix}Button`];
      let previousFocus;
      const close = () => {
        try { sessionStorage.setItem(`avolt_notified_${market.prefix}`, 'true'); } catch {}
        modal.classList.remove('is-visible');
        modal.setAttribute('aria-hidden', 'true');
        previousFocus?.focus();
      };
      go.onclick = () => {
        // Preserve collection destinations for US as before. CA handles are not verified.
        const path = location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
        location.href = market.origin + (country === 'US' && path.startsWith('/collections/') ? path : '/');
      };
      stay.onclick = close;
      modal.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === go) { event.preventDefault(); stay.focus(); }
          else if (!event.shiftKey && document.activeElement === stay) { event.preventDefault(); go.focus(); }
        }
      });
      setTimeout(() => {
        previousFocus = document.activeElement;
        modal.classList.add('is-visible');
        modal.setAttribute('aria-hidden', 'false');
        go.focus();
      }, 800);
    }).catch(() => {});
})();
